import api from './api';

// Service du module « Google Analytics » (GA4).
const gaApi = {
  // Liste des sites (propriétés GA4) accessibles, groupés par compte.
  getProperties: () => api.get('/google-analytics/properties'),

  // Rapport complet pour un site + période. compare = comparaison vs période précédente.
  getReport: ({ property, start, end, compare }) =>
    api.get('/google-analytics/report', {
      params: { property, start, end, compare: compare ? 1 : 0 },
    }),

  // Temps réel (utilisateurs actifs maintenant).
  getRealtime: (property) =>
    api.get('/google-analytics/realtime', { params: { property } }),

  // Audit IA de la santé de la mesure.
  getAudit: (property) => api.get('/google-analytics/audit', { params: { property } }),
  runAudit: (property) => api.post('/google-analytics/audit', { property }),

  // Configuration (super-admin) : mapping propriété → concession (gestion des droits).
  getConfig: () => api.get('/google-analytics/config'),
  setPropertyConcession: (propertyId, concession_id) =>
    api.patch(`/google-analytics/properties/${propertyId}`, { concession_id }),
};

export default gaApi;
